import { useMessageToState } from "./useMessageToState";

const getProductCategory = (editor: eXpress.core.IEditor) =>
	editor.definition?.product.category ?? undefined;

/** Returns the current productCode */
export function useProductCategory() {
	return useMessageToState({
		name: "useProductCategory",
		filterMessage: eXpress.core.isProductCodeChanged,
		getState: getProductCategory,
	});
}
